window.prismic = {
    endpoint: "https://harwoodlevitt.prismic.io/api/v2",
};

function linkResolver(doc) {
    // Return the path depending on Prismic Document's type
    // If it is a Single Custom Type with the API ID of "home"
    if (doc.type === "home") {
        return "/";
    }
    // If it is a Single Custom Type with the API ID of "example"
    if (doc.type === "ideas") {
        return "/ideas/" + doc.uid;
    }
    // Default to the root
    return "/";
}

Vue.use(PrismicVue, {
    endpoint: window.prismic.endpoint,
    // linkResolver: linkResolver
});

const app = new Vue({
    el: "#app",
    data: {
        loaded: false,
        results: null,
        resultsShown: null,

        // Home
        home: null,
        who: null,

        hiring: false,

        // What we do
        whatWeDo: null,
        whatWeDoActive: null,
        selected: 0,

        // Clients
        clients: {},
        clientsPartTwo: {},

        // Smart Wednesday
        wed: {},
        checkedSessions: [],
        arraySessions: {},
        mailSuccess: null,
        mailAlert: null,
        emailSmart: null,

        // Ideas
        cat: {},
        currentCat: null,
        showAll: true,
        currentRoute: window.location.pathname,
        fields: {
            articleContent: null,
            title: null,
            subtitle: null,
            image: null,
            uid: "test",
        },
        similar: [],
        related: [],
        i: 3,
        results: {},
        showMoreBtn: true,

        // Team members
        team: {},
        teamList: [],
        teamListAdvisors: [],
        teamActive: true,
        teamActiveAdvisors: true,
        speActive: false,
        currentTeam: null,
        currentTeamAdvisors: {},
        partnerActive: {},
        partnerActiveAdvisors: {},
        bioVisible: false,
        popupBio: false,
        selectedPartner: {},
        // Alumni

        alumni: {},
        alumniList: [],
        currentAlumni: {},

        //Job Offer
        jobOffers: {},
        jobFields: {
            jobTitle: null,
            jobDescription: null,
        },

        //Map
        privacy: false,
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
        swiperAdvisors() {
            return this.$refs.mySwiperAdvisors.swiper;
        },
    },
    methods: {
        // Togle TEAM POPUP
        toggleTeamPopup(partner) {
            this.popupBio = !this.popupBio;
            this.selectedPartner = partner;
            console.log(partner)
        },
        // Get home
        getHome() {
            this.$prismic.client.getByID("XOULexEAACkAwXqr").then((response) => {
                this.home = response;
                if (this.home.data.hiring == "Yes") {
                    this.hiring = true;
                } else {
                    this.hiring = false;
                }
            });
            return true;
        },
        getWho() {
            this.$prismic.client.getByID("XOersxEAACkAzM16").then((response) => {
                this.who = response;
            });
            return true;
        },
        // Génère les catégories en fetchant les ideas
        getContent() {
            this.$prismic.client
                .query(
                    this.$prismic.Predicates.at("document.type", "ideas"),
                    // Order by first publication date from oldest to most recent
                    {
                        orderings: "[document.data.change_date], [document.last_publication_date]",
                        pageSize: 50,
                    }
                )
                .then((response) => {
                    // Ajoute les Ideas au results
                    this.results = response.results;

                    this.resultsShown = this.results.slice(0, 3);
                    // Génère les catégories
                    this.results.forEach((element) => {
                        var select = element.data.category;
                        if (!this.cat[select]) {
                            this.cat[select] = 1;
                        } else {
                            this.cat[select] += 1;
                        }
                    });
                });
        },

        getWhatWeDo() {
            this.$prismic.client.query(this.$prismic.Predicates.at("document.type", "what_we_do_")).then((response) => {
                this.whatWeDo = response.results[0].data.body[0].items;
                if (!this.loaded) {
                    this.whatWeDoActive = response.results[0].data.body[0].items[0];
                }
            });
        },
        setWhatActive(blu) {
            this.whatWeDoActive = blu;
            this.selected = this.whatWeDo.indexOf(blu);
        },

        getTeam() {
            this.$prismic.client
                .query(this.$prismic.Predicates.at("document.type", "team_members"))
                .then((response) => {
                    this.team = response.results[0].data.body[0].items;
                    this.teamListAdvisors = response.results[0].data.body[1].items;
                    this.currentTeam = this.team[0];
                });
        },

        showBio() {
            if (this.bioVisible == true) {
                this.bioVisible = false;
            } else {
                this.bioVisible = true;
            }
        },

        getAlumni() {
            this.$prismic.client.query(this.$prismic.Predicates.at("document.type", "hlc_alumni")).then((response) => {
                this.alumni = response.results[0].data.body[0].items;
                this.currentAlumni = this.alumni[0];
            });
        },

        setCurrentTeam(id) {
            this.currentTeam = id;
        },

        setCurrentAlumni(id) {
            this.currentAlumni = id;
        },

        setCurrentTeamAdvisors(id) {
            this.currentTeamAdvisors = id;
        },

        teamBtns(slide) {
            if (slide == "team") {
                this.teamActive = true;
                this.speActive = false;
                fullpage_api.moveSlideRight();
            } else if (slide == "spe") {
                this.teamActive = false;
                this.speActive = true;
                fullpage_api.moveSlideLeft();
            }
        },
        getClients() {
            this.$prismic.client.query(this.$prismic.Predicates.at("document.type", "clients")).then((response) => {
                this.clients = response.results[0].data.body[0].items.slice(0, 29);
                this.clientsPartTwo = response.results[0].data.body[0].items.slice(29, 58);
            });
        },
        getWednesday() {
            this.$prismic.client
                .query(this.$prismic.Predicates.at("document.type", "smart_wednesday"))
                .then((response) => {
                    this.wed = response.results[0].data.body[0].items;
                    this.wed.forEach((element) => {
                        var date = null;
                        var list = null;
                        date = new Date(element.session_date);
                        var CurrentDate = new Date();
                        if (date > CurrentDate) {
                            list = date.toUTCString().split(" ");
                            element.date_short = list[1] + " " + list[2];
                        }
                    });
                });
        },
        setWedDates() {
            if (this.wed.length > 0) {
                this.wed.forEach((element) => {
                    date = new Date(element.session_date);
                    list = date.toUTCString().split(" ");
                    element.date_short = list[1] + " " + list[2];
                });
            }
        },
        getJobOffers(idea) {
            this.$prismic.client.query(this.$prismic.Predicates.at("document.type", "job_offer")).then((response) => {
                this.jobOffers = response.results;
            });
        },

        currentCaty(toShow) {
            this.resultsShown = this.results;
            this.currentCat = toShow;
            this.showAll = false;
            this.showMoreBtn = false;
            setTimeout(function () {
                fullpage_api.reBuild();
            }, 700);
            $(".idea").scrollTop(0);
            $(".section-ideas .fp-scroller").load(function () {
                fullpage_api.reBuild();
            });
        },

        showAllMethod() {
            this.showMore(true);
            this.showAll = true;
            this.currentCat = null;

            fullpage_api.reBuild();
            this.showMoreBtn = false;
        },
        showMore(all) {
            if (all) {
                this.resultsShown = this.results;
            } else {
                this.i = this.i + 6;
                this.resultsShown = this.results.slice(0, this.i);
            }
            $(".section-ideas .fp-scroller").load(function () {
                fullpage_api.reBuild();
            });
            setTimeout(function () {
                fullpage_api.reBuild();
            }, 700);
        },
        setSimilars(idea) {
            this.similar = [];
            this.related = [];
            if (idea) {
                if (idea.data.similar_article) {
                    this.similar.push(idea.data.similar_article);
                }
                if (idea.data.similar_article_2) {
                    this.similar.push(idea.data.similar_article_2);
                }
                if (idea.data.similar_article_3) {
                    this.similar.push(idea.data.similar_article_3);
                }
            }
            this.similar.forEach((element) => {
                if (element.id) {
                    this.$prismic.client.getByID(element.id).then((document) => {
                        this.related.push(document);
                    });
                }
            });
        },

        showArticle(idea) {
            if (idea) {
                this.setSimilars(idea);
                this.fields.articleContent = idea.data.article_content;
                this.fields.title = idea.data.title;
                this.fields.subtitle = idea.data.subtitle;
                this.fields.image = idea.data.image;
                this.fields.twitter = idea.data.twitter;
                this.fields.facebook = idea.data.facebook;
                this.fields.linkedin = idea.data.linkedin;
                this.fields.uid = idea.uid;

                $(".idea").addClass("active");
                $(".idea").scrollTop(0);
            }
        },

        hideArticle() {
            console.log("ah");

            fullpage_api.setAllowScrolling(true);
        },
        getRoute() {
            var searchParams = new URLSearchParams(window.location.href);
            for (let p of searchParams) {
                if (p != "") {
                    this.urlArticle(p[1]);
                }
            }
        },

        urlArticle(uid) {
            this.$prismic.client.getByUID("ideas", uid).then((document) => {
                this.showArticle(document);
            });
        },
        onSetTranslate() {
            console.log("onSetTranslate");
        },

        showJob(idea) {
            this.jobFields.jobTitle = idea.job_title;
            this.jobFields.jobDescription = idea.job_description;
            $(".job").addClass("active");
            $(".job").scrollTop(0);
        },

        hideJob() {
            $(".job").removeClass("active");
            fullpage_api.destroy("all");
            fullpage_api.init();
            fullpage_api.silentMoveTo("sectionHire");
        },

        toObject(arr) {
            var rv = {};
            for (var i = 0; i < arr.length; ++i) rv[i] = arr[i];
            return rv;
        },
        mailSuccessCallback(response) {
            this.mailSuccess = true;
        },
        mailAlertCallback(error) {
            this.mailSuccess = true;
        },
        sendMail() {
            this.checkedSessions.unshift(this.emailSmart);
            window.emailjs.send("mailjet", "template_17grX2v6_clone", this.toObject(this.checkedSessions));
            window.emailjs.send("mailjet", "template_17grX2v6", this.toObject(this.checkedSessions)).then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    var link = document.getElementById("submit");
                    link.style.display = "none";
                    var mailAddress = document.getElementById("email");
                    mailAddress.style.display = "none";

                    var alert = document.getElementById("alert-success");
                    alert.style.display = "inline-block";
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
        },
        showPrivacy() {
            if (this.privacy == true) {
                this.privacy = false;
            } else {
                this.privacy = true;
            }
        },

        deviceSize() {},
    },
    created() {
        this.getWho();
        this.getHome();
        this.getWhatWeDo();
        this.getContent();
        this.getClients();
        this.getWednesday();
        this.getJobOffers();
        this.setWedDates();
    },
    beforeMount() {
        this.getTeam();
        this.getAlumni();
        this.setCurrentTeam();
        this.setCurrentAlumni();
        this.getRoute();
    },
});
